var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgManageAds(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "currentColor",
    iconName: "IconPersonalizationFill",
    className: "css-6xix1i",
    viewBox: "0 0 48 48",
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.8 12.4a8.4 8.4 0 1 1-16.8 0 8.4 8.4 0 0 1 16.8 0ZM22.65 9.82a.3.3 0 0 0 .3.23 13.9 13.9 0 0 1 13.73 11.8c.03.23.13.43.29.6l3.23 3.23c.58.57 1.55.25 1.6-.56A18.9 18.9 0 0 0 22.2 5.06c-.78.03-1.16.94-.77 1.61.55.97.97 2.03 1.22 3.15ZM25.22 42.7c.78-.1 1.06-1.04.5-1.6l-3-3a1.04 1.04 0 0 0-.67-.3 13.9 13.9 0 0 1-13-13.86.3.3 0 0 0-.23-.29 11.47 11.47 0 0 1-3.15-1.22c-.67-.39-1.58-.01-1.6.76-.02.25-.02.5-.02.75A18.9 18.9 0 0 0 25.22 42.7ZM23.56 33.25a.87.87 0 0 0 0 1.23l9.26 9.26c.34.35.9.35 1.24 0l9.26-9.26a.87.87 0 0 0 0-1.23l-9.26-9.27a.87.87 0 0 0-1.24 0l-9.26 9.27Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgManageAds);
export default __webpack_public_path__ + "static/media/manage-ads.6ae606394253b54e4ec9bad874cc574b.svg";
export { ForwardRef as ReactComponent };